// src/odoo/customers/components/utils.ts
// All comments are in English.

export function formatHKD(amount: number | null | undefined): string {
  if (amount == null || Number.isNaN(amount)) return "HK$0";
  return `HK$${amount.toLocaleString("en-HK", {
    maximumFractionDigits: 0,
  })}`;
}

export function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString("en-GB");
}
